import React, { memo, useEffect, useState } from 'react'
import styles from './distributionTaskTimeAnalysisOther.less'
import { Flex, Select, Statistic } from 'antd'
import { request } from '../../../../../../tool/http'
// import HumanLineChart from '@/pages/containers/dashboard/contentView/view/showEchart/humanLineChart/humanLineChart'


function DistributionTaskTimeAnalysisOther(props: any) {
  // console.log('每天的在线人数---展示', props)
  // const [showType, setShowType] = useState(props.contentMsg?.dataConfig?.contentParams?.typeShowSel || [1])
  let showType = props.contentMsg?.dataConfig?.contentParams?.typeShowSel || [1]
  const [errorMsg, setErrorMsg] = useState('')
  const [time, setTime] = useState(1)
  const [data, setData] = useState<any>([])
  const [option, setOption] = useState<any>({})
  const [takeSelectType, setTakeSelectType] = useState(0)
  //时间类型
  const [timeType, setTimeType] = useState(1)

  //请求业务数据
  const getBusinessData = () => {
    setErrorMsg('')
    let group = 'day'
    group = time === 1 ? (timeType === 1 ? 'hour' : 'localHour') : (timeType === 1 ? 'day' : 'localDay')
    request(`${props.contentMsg?.proConfig?.apiPrefix}/taskStatistics/getDistributionTimes`, {
      data: {
        businessType: props.contentMsg?.proConfig?.usageParams?.usageCode,  //1.公司 2.空间 3.执行单元
        businessId: [props.contentMsg?.proConfig?.usageParams?.businessId],
        time,
        type: takeSelectType ? takeSelectType : '',
        group: group
      }
    }).then((res) => {
      if (res.code === 200) {
        setData(res.data)
      } else {
        setErrorMsg(res.message)
      }
    }).catch((err) => {
      setErrorMsg(err.toString())
    })
  }
  useEffect(() => {
    getBusinessData()
  }, [showType, time, props.dataUpdate, takeSelectType, timeType])

  //获取图表数据
  const getOption = () => {
    let dataFilter = [] as any[]
    //对应数据字段
    let dataKey: any = {
      running: '执行中',
      success: '成功',
      fail: '失败',
      noExec: '未执行',
      timeout: '超时',
      // undistributed: '未分发'
    }
    Object.keys(dataKey).forEach((key: any) => {
      if (dataKey[key]) {
        dataFilter.push({
          _id: dataKey[key],
          count: data.map((item: any) => item[key] || 0)
        })
      }
    })
    let xAxis = [
      {
        axisLabel: {
          rotate: 30
        },
        data: data.map((item: any) => {
          return time === 1 ? (item?.hour?.slice(8) || item?.localHour?.slice(8)) + '时' : (item?.day || item?.localDay)
        })
      }
    ]
    let series = dataFilter.map((item: any) => {
      return {
        name: item._id,
        type: 'line',
        xAxisIndex: 0,
        data: item.count,
        // areaStyle: {}
      }
    })
    let option = {
      xAxis,
      series
    }
    setOption(option)
  }
  useEffect(() => {
    if (data.length > 0) {
      getOption()
    }
  }, [data])
  return (
    <div className={styles.outer}>
      <div
        className={styles.chartBox + " swiper-no-swiping"}
      >
        {
          errorMsg
            ? <div className={styles.errorMsg}>
              {errorMsg}
            </div>
            : <Flex vertical style={{ width: '100%', height: '100%' }}>
              <Flex>
                <Flex justify='end' flex={1} className={" swiper-no-swiping"}>
                  <Select
                    style={{ width: "120px" }}
                    value={time}
                    onChange={(v) => {
                      setTime(v)
                    }}
                    options={[
                      { label: "今日", value: 1 },
                      { label: "30日", value: 30 },
                      { label: "15日", value: 15 },
                      { label: "7日", value: 7 },
                    ]}
                  >
                  </Select>
                  <Select style={{ width: "120px", marginLeft: '10px' }}
                    value={takeSelectType}
                    onChange={(v) => {
                      setTakeSelectType(v)
                    }}
                    options={[
                      { label: "全部任务", value: 0 },
                      { label: "单次任务", value: 2 },
                      { label: "周期任务", value: 3 },
                    ]} >

                  </Select>
                  <Select style={{ width: "120px", marginLeft: '10px' }}
                    value={timeType}
                    onChange={(v) => {
                      setTimeType(v)
                    }}
                    options={[
                      { label: "北京时间", value: 1 },
                      { label: "当地时间", value: 2 },
                    ]} >
                  </Select>
                </Flex>
              </Flex>

              {/* {showType.includes(1) && <HumanLineChart option={option}></HumanLineChart>} */}
            </Flex>
        }
      </div>
    </div>

  )
}
export default memo(DistributionTaskTimeAnalysisOther)